<template>
  <div class="login-content expired">
    <div class="ibf-h1-larger login-title">
      {{ $t('login.licenseForm.title') }}
    </div>
    <div class="login-subtitle">
      <div>{{ $t('login.licenseForm.firstLogin.subtitle.A') }}</div>
      <div>{{ $t('login.licenseForm.firstLogin.subtitle.B') }}</div>
      <div>{{ $t('login.licenseForm.firstLogin.subtitle.C') }}</div>

      <!-- <br /> -->
      <!-- {{ $t('login.licenseForm.subtitle.B') }} -->
      <!-- <span class="ibf-text-list2">{{ $t('login.licenseForm.subtitle.C') }}</span> -->
    </div>
    <q-form>
      <div class="login-form login-form-first-login">
        <div class="login-input-fields">
          <!-- <label class="login-label" for="licenseKey">{{ $t('login.licenseForm.licenseInput.text') }}</label> -->
          <div class="login-input-field">
            <q-input
              id="licenseKey"
              ref="license-key-field"
              data-testid="login-form--license-key-input"
              v-model="licenseKey"
              dense
              autofocus
              tabindex="1"
              type="text"
              input-class="brand_almost_black"
              name="License"
              bg-color="white"
              :placeholder="$t('login.licenseForm.licenseInput.placeholder')"
              stack-label
              outlined
              :clearable="!isFormDisabled"
              :rules="[val => getIsLicenseValidWarning || $t('login.licenseForm.licenseInput.validation')]"
              @keydown="setLicenseValidChecked($event)"
            >
              <template #prepend>
                <q-icon class="incredicon-key login-input-icon" />
              </template>
            </q-input>
          </div>
        </div>
        <div class="login-buttons">
          <div>
            <q-btn
              id="login-submit"
              data-testid="login-form--login-button"
              flat
              type="submit"
              rounded
              no-caps
              :disable="isFormDisabled"
              tabindex="2"
              class="submit-button ibf-h4 incredi-button-ibx primary-strong"
              :label="$t('login.licenseForm.submitLabel')"
              @click.stop.prevent="submitLicense(license?.key)"
            >
            </q-btn>
          </div>
          <div id="login-support-link">
            <a
              data-testid="login-form--support-link"
              tabindex="4"
              :href="supportMailUrl"
              >{{ $t('login.licenseForm.supportLink') }}</a
            >
          </div>
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
import LicenseScript from '@/views/login/loginComponents/licenseFormMixins.vue';
import { defineComponent, inject } from 'vue';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';

export default defineComponent({
  name: 'LicenseForm',
  mixins: [LicenseScript],
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);

    const GQL_useLicenseInfoQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    return { GQL_useLicenseInfoQuery };
  },
  computed: {
    license() {
      return this.GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../commonLoginComponentsStyle';
.login-form-first-login {
  :deep(i) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .login-input-fields {
    margin-top: 30px !important;
    margin-bottom: 192px;
    .q-field--error {
      :deep(.login-input-icon) {
        color: $-system-app-error;
      }
    }
    .q-field--focused {
      &:not(.q-field--error) {
        :deep(.login-input-icon) {
          color: $-text-text-primary;
        }
      }
    }
  }
  :deep(.q-field--outlined) {
    height: 50px;
    * {
      height: 50px;
    }
  }
  :deep(.q-field__native) {
    height: 48px !important;
  }
}
.login-buttons {
  width: 330px;
  text-align: center;

  & span {
    margin-left: -30px;
  }

  & .submit-button {
    width: 300px;
  }
}
</style>
